import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Star, Landmark } from "lucide-react";

const KomikKrakow = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Kraków">
    <SeoSection title="Występy komediowe w Krakowie">
      <p>Kraków to drugie co do wielkości miasto w Polsce i jeden z najważniejszych ośrodków biznesowych oraz kulturalnych. Scena stand-upowa w Krakowie jest prężna i dynamiczna. Oferujemy profesjonalne występy komediowe na terenie Krakowa i Małopolski - od kameralnych spotkań firmowych po duże gale i konferencje.</p>
    </SeoSection>

    <SeoSection title="Eventy firmowe w Krakowie">
      <p>Krakowski rynek eventowy jest bogaty i zróżnicowany. Firmy z branży IT, BPO, finansowej i kreatywnej regularnie organizują eventy integracyjne, konferencje i gale. Nasi komicy doskonale znają krakowską scenę i potrafią dopasować materiał do lokalnej publiczności, nawiązując do krakowskiego klimatu i kultury.</p>
    </SeoSection>

    <SeoSection title="Popularne lokalizacje eventowe w Krakowie">
      <SeoFeatureGrid features={[
        { icon: Building2, title: "Hotele w centrum", description: "Sheraton, Grand Hotel, Hotel Stary" },
        { icon: Landmark, title: "Centra konferencyjne", description: "ICE Kraków, EXPO Kraków" },
        { icon: MapPin, title: "Kazimierz i Podgórze", description: "Restauracje i sale bankietowe w kultowych dzielnicach" },
        { icon: Star, title: "Przestrzenie industrialne", description: "Fabryka Schindlera, Dolne Młyny, zamki w okolicach" },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika w Krakowie">
      <p>Niezależnie od wielkości i charakteru Twojego wydarzenia w Krakowie - mamy odpowiedniego komika. Skontaktuj się z nami, opisz swoje potrzeby, a my zaproponujemy idealny format występu i przygotujemy spersonalizowaną ofertę.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikKrakow;
